import type { ThemeOptions } from '@mui/material';

const componentStyleOverrides: ThemeOptions['components'] = {
  MuiButton: {
    styleOverrides: {
      root: {
        textTransform: 'inherit',
        height: 40,
        fontWeight: 500,
      },
    },
  },
  MuiTab: {
    styleOverrides: {
      root: {
        textTransform: 'inherit',
        minHeight: 0,
      },
    },
  },
  MuiInputLabel: {
    defaultProps: {
      size: 'small',
    },
  },
  MuiSelect: {
    styleOverrides: {
      select: ({ theme }: { theme: any }) => ({
        height: 24,
        backgroundColor: theme.palette.background.default,
        paddingTop: 8,
        paddingBottom: 8,
        display: 'inline-flex',
        alignItems: 'center',
      }),
    },
  },
  MuiTextField: {
    defaultProps: {
      size: 'small',
    },
    styleOverrides: {
      root: ({ theme }: { theme: any }) => ({
        '& .MuiInputBase-input:not(.MuiInputBase-inputMultiline)': {
          height: 24,
          display: 'inline-flex',
          alignItems: 'center',
        },
        '.MuiInputBase-root': {
          backgroundColor: theme.palette.background.default,
        },
      }),
    },
  },
};

export default componentStyleOverrides;
